import { 
        signInAction, signOutAction, updateUserStateAction,
        fetchProductsInCartAction, fetchOrdersHistoryAction,
        updateEmailAction
} from './actions'
import { push } from 'connected-react-router'
import { auth, db, FirebaseTimestamp, functions } from '../../firebase/index'
import { CardElement } from '@stripe/react-stripe-js'

const usersRef = db.collection('users')

// 商品をユーザーのカートに追加
export const addProductToCart = (addedProduct) => {
    return async (dispatch, getState) => {
        const uid = getState().users.uid
        const cartRef = usersRef.doc(uid).collection('cart')
        // 既にカートに同一商品あるかを判定
        const sameProductInCart = []
        await cartRef.where("productId","==", addedProduct.productId).get()
                     .then(snapshots => snapshots.forEach(snapshot => sameProductInCart.push(snapshot.data())))
        if (sameProductInCart.length > 0) {
            await cartRef.doc(sameProductInCart[0].cartId).set({quantity: sameProductInCart[0].quantity + 1},{merge: true})
        } else {
            addedProduct['cartId'] = cartRef.doc().id
            await cartRef.doc(addedProduct['cartId']).set(addedProduct)
        }
        dispatch(push('/cart'))
    }
}

// 注文履歴取得
export const fetchOrdersHistory = () => {
    return async (dispatch, getState) => {
        const uid = getState().users.uid
        const list = []
        usersRef.doc(uid)
                .collection('orders')
                .orderBy('updated_at', 'desc')
                .get()
                .then(snapshots => {
                    snapshots.forEach(snapshot => {
                        const data = snapshot.data()
                        list.push(data)
                    })
                    dispatch(fetchOrdersHistoryAction(list))
                })
    }
}

// カートに入れていた商品取得
export const fetchProductsInCart = (products) => {
    return async (dispatch) => {
        dispatch(fetchProductsInCartAction(products))
    }
}

// 認証情報のリッスン
export const listenAuthState = () => {
    return async (dispatch) => {
        return auth.onAuthStateChanged( user => {
            if (user) {
                const uid = user.uid
                usersRef.doc(uid).get()
                        .then( snapshot => {
                            const data = snapshot.data()
                            if (!data) {
                                throw new Error('ユーザーデータが存在しません。')	
                            }
                            dispatch(signInAction({
                                email: data.email,
                                isSignedIn: true,
                                role: data.role,
                                uid: uid,
                                lastname: data.lastname,
                                firstname: data.firstname,
                                customer_id: (data.customer_id) ? data.customer_id : '',
                                payment_method_id: (data.payment_method_id) ? data.payment_method_id : ''
                            }))
                        });
            } else {
                // dispatch(push('/signin'))
            }
        })
    }
}

// パスワードリセット
export const resetPassword = (email) => {
    return async (dispatch) => {
        if (email === '') {
            alert('未入力の必須項目があります')
            return false
        }

        return auth.sendPasswordResetEmail(email)
                   .then(() => {
                        alert('入力されたアドレスにパスワードリセットのメールを送信しました')
                        dispatch(push('/signin'))
                   })
                   .catch(() => alert('パスワードリセットに失敗しました'))
    }
}

// メールアドレス変更
export const changeEmail = (email, emailConfirm) => {
    return async (dispatch, getState) => {

        if (email === '' || emailConfirm === '' ) {
            alert('未入力の必須項目があります')
            return false
        }
        // email validation
        const regexEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
        if (!regexEmail.test(email)) {
            alert('メールアドレスの形式が不正です。もう1度お試しください。')
            return false
        }
        if (email !== emailConfirm) {
            alert('メールアドレスが一致しません')
            return false
        }

        const uid = getState().users.uid
        const timestamp = FirebaseTimestamp.now()

        const updateData = {
            updated_at: timestamp,
            email
        }

        return auth.currentUser.updateEmail(email)
                               .then(() => {
                                    // Firestore上での変更処理
                                    usersRef.doc(uid)
                                            .set(updateData, {merge: true})
                                            .then(() => {
                                                // Store上での変更処理
                                                dispatch(updateEmailAction(email))
                                                alert('メールアドレスを変更しました')
                                            })
                               })
                               .catch(() => alert('メールアドレスの変更に失敗しました'))
    }
}
// パスワード変更
export const changePassword = (password, passwordConfirm) => {
    return async (dispatch) => {

        if (password === '' || passwordConfirm === '' ) {
            alert('未入力の必須項目があります')
            return false
        }
        // password validation
        const regexPassword = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[a-zA-Z\d]{8,40}$/
        if (!regexPassword.test(password)) {
            alert('パスワードの形式が不正です。パスワードは半角英小文字大文字数字それぞれ1種類以上含む8文字以上40文字以下で設定できます。')
            return false
        }
        if (password !== passwordConfirm) {
            alert('パスワードが一致しません')
            return false
        }

        return auth.currentUser.updatePassword(password)
                               .then(() => alert('パスワードを変更しました'))
                               .catch(() => alert('パスワードの変更に失敗しました'))
    }
}
// アカウント削除
export const deleteAccount = () => {
    return async (dispatch) => {
        auth.currentUser.delete()
                        .then(() => {
                            // Firestore上での削除処理
                            // Store上での削除処理
                            alert('退会処理が完了しました')
                            dispatch(push('/'))
                        })
                        .catch(() => alert('退会処理に失敗しました'))
    }
}

// プロフィール更新
export const updateProfile = (lastname,firstname,postalCode,prefecture,city,street,tel) => {
    return async (dispatch, getState) => {
        
        // Validation
        if (lastname === '' || firstname === '' ) {
            alert('未入力の必須項目があります')
            return false
        }
        // 郵便番号Validation
        if (postalCode) {
            const regexPostalCode = /^[0-9]{7}$/
            if (!regexPostalCode.test(postalCode)) {
                alert('郵便番号は数字7桁で入力してください（ハイフン不要）')
                return false
            }
        }
        // 電話番号Validation
        if (tel) {
            const regexTel = /^[0-9]{10,11}$/
            if (!regexTel.test(tel)) {
                alert('電話番号は10桁または11桁の数字で入力してください（ハイフン不要）')
                return false
            }
        }

        const uid = getState().users.uid
        const timestamp = FirebaseTimestamp.now()

        const userUpdatedData = {
            updated_at: timestamp,
            lastname,firstname,
            postalCode: postalCode ? postalCode : "",
            prefecture: prefecture ? prefecture : "",
            city: city ? city : "",
            street: street ? street : "",
            tel: tel ? tel : ""
        }
        const mailData = {
            to: 'Jeff.S.63mSwHfl@gmail.com',
            subject: '【Weth-Store】プロフィールを更新しました',
            text: `
登録された情報は下記の通りです。
お名前：${lastname} ${firstname}
郵便番号：${postalCode ? postalCode : "未入力"}
都道府県：${prefecture ? prefecture : "未入力"}
市区町村：${city ? city : "未入力"}
番地以降：${street ? street : "未入力"}
電話：${tel ? tel : "未入力"}
`
        }
        const sendMail = functions.httpsCallable('sendMail')
        // DBを更新
        usersRef.doc(uid)
                .set(userUpdatedData, {merge: true})
                .then(()=>{
                    alert('プロフィールを更新しました')
                    sendMail(mailData)
                    dispatch(push('/profile'))
                })
                .catch(() => alert('プロフィールの更新に失敗しました'))
    }
}

// メールマガジン購読設定
export const updateSubscription = (userId, isSubscribe) => {
    return async (dispatch) => {
        const timestamp = FirebaseTimestamp.now()
        const userUpdatedData = {
            updated_at: timestamp,
            is_subscribe: isSubscribe
        }
        console.log(userUpdatedData)
        // DBを更新
        usersRef.doc(userId)
                .set(userUpdatedData, {merge: true})
                .then(()=>{
                    alert('メールマガジン購読設定を更新しました')
                })
                .catch(() => alert('メールマガジン購読設定に失敗しました'))
    }
}

// サインイン
export const signIn = (email, password) => {
    return async (dispatch) => {
        if (email === '' || password === '') {
            alert('未入力の必須項目があります')
            return false
        }

        auth.signInWithEmailAndPassword(email, password)
            .then(result => {
                const user = result.user
                if (user) {
                    const uid = user.uid
                    usersRef.doc(uid).get()
                            .then( snapshot => {
                                const data = snapshot.data()
                                dispatch(signInAction({
                                    cart: [{}],
                                    isSignedIn: true,
                                    role: data.role,
                                    uid: uid,
                                    lastname: data.lastname,
                                    firstname: data.firstname,
                                    email: data.email,
                                    ustomer_id: (data.customer_id) ? data.customer_id : '',
                                    payment_method_id: (data.payment_method_id) ? data.payment_method_id : ''
                                }))

                                dispatch(push('/'))
                            })
                }
            }) 
    }
}

// サインアウト
export const signOut = () => {
    return async (dispatch, getState) => {

        const uid = getState().users.uid
        await usersRef.doc(uid).collection('cart').get()
            .then(snapshots => {
                snapshots.forEach(snapshot => {
                    usersRef.doc(uid).collection('cart').doc(snapshot.id).delete()
                })
            });

        auth.signOut()
            .then(() => {
                dispatch(signOutAction())
                dispatch(push('/signin'))
            })
    }
}

// サインアップ
export const signUp = (lastname, firstname, email, password, confirmPassword) => {
    return async (dispatch) => {
        return auth.createUserWithEmailAndPassword(email, password)
            .then(result => {
                const user = result.user
                if (user) {
                    const uid = user.uid
                    const timestamp = FirebaseTimestamp.now()

                    const userInitialData = {
                        created: timestamp,
                        email: email,
                        role: "customer",
                        uid: uid,
                        updated_at: timestamp,
                        lastname: lastname,
                        firstname: firstname,
                    }
                    const mailData = {
                        to: email,
                        subject: '【T3】会員登録が完了しました',
                        text: `
----------------------------------------------------------------------
このメールはシステムからの自動返信です。
----------------------------------------------------------------------
${lastname} ${firstname}様

この度は会員登録いただきありがとうございます。
会員登録が完了しました。

さっそく【T3】を使ってみましょう！
URL：https://ec.tothetop.jp/

ご利用に際し不明な点がございましたら、お気軽にお問い合わせください。
今後とも【T3】をよろしくお願い申し上げます。


━━━━━━━━━━━━━━━━━
    【T3】ニューネックス株式会社
----------------------------------
〒153-0042 東京都目黒区青葉台1-27-3 2F
    TEL：03-5544-9770
    E-mail  ：shop@newnex.net
━━━━━━━━━━━━━━━━━
`
                    }
                    const sendMail = functions.httpsCallable('sendMail')

                    db.collection('users').doc(uid).set(userInitialData)
                        .then(()=>{
                            sendMail(mailData)
                            dispatch(push('/signup/complete'))
                        })
                }
            })
    }
}

// ペイメント関連

// API
const headers = new Headers();
headers.set('Content-type', 'application/json');
const BASE_URL = 'https://weth-store.web.app';

// 新規顧客登録
const createCustomer = async (email, paymentMethodId, uid) => {
    const response = await fetch(BASE_URL + '/v1/customer', {
        method: 'POST',
        headers,
        body: JSON.stringify({
            email,
            paymentMethod: paymentMethodId,
            userId: uid,
        })
    })

    const customerResponse = await response.json()
    return JSON.parse(customerResponse.body)
}

// カード情報の更新
export const updatePaymentMethod = async (customerId, prevPaymentMethodId, nextPaymentMethodId) => {
    const response = await fetch(BASE_URL + '/v1/updatePaymentMethod', {
        method: 'POST',
        headers,
        body: JSON.stringify({
            customerId,
            prevPaymentMethodId,
            nextPaymentMethodId,
        })
    })

    const paymentMethodResponse = await response.json()
    const paymentMethod = JSON.parse(paymentMethodResponse.body)
    return paymentMethod.card
}

// Stripeへカード情報の登録（for 新規&更新）
export const registerCard = (stripe, elements, customerId) => {
    return async (dispatch, getState) => {
        const user = getState().users
        const email = user.email
        const uid = user.uid

        if (!stripe || !elements) {
            return;
          }
      
          const cardElement = elements.getElement(CardElement);
      
          const {error, paymentMethod} = await stripe.createPaymentMethod({
            type: 'card',
            card: cardElement,
          });

          if (error) {
            alert(error.message);
            return;
          }

          const paymentMethodId = paymentMethod.id

          if (customerId === '') {
              const customerData = await createCustomer(email, paymentMethodId, uid)
    
              if (!customerData.id) {
                  alert('カード情報の登録に失敗しました')
                  return;
              } else {
                  const updateUserState = {
                      customer_id: customerData.id,
                      payment_method_id: paymentMethodId,
                  }
    
                  db.collection('users').doc(uid)
                    .update(updateUserState)
                    .then(() => {
                        dispatch(updateUserStateAction(updateUserState))
                        dispatch(push('/mypage'))
                    }).catch(() => {
                        // delete data from stripe
                        alert('カード情報の登録に失敗しました（Firestoreエラー）');
                        return;
                    })
              }
          } else {
              const prevPaymentMethodId = getState().users.payment_method_id;
              const updatedPaymentMethod = await updatePaymentMethod(customerId, prevPaymentMethodId, paymentMethodId);
              if (!updatedPaymentMethod) {
                  alert('カード情報の更新に失敗しました')
              } else {
                  const userState = {
                      payment_method_id: paymentMethodId
                  }
                  db.collection('users').doc(uid)
                    .update(userState)
                    .then(() => {
                        dispatch(updateUserStateAction(userState))
                        alert('カード情報を更新しました')
                        dispatch(push('/mypage'))
                    }).catch(() => {
                        alert('カード情報の更新に失敗しました(firebase)')
                    })
              }
          }

    }
}


// 顧客カード情報取得
export const retrievePaymentMethod = async (paymentMethodId) => {
    const response = await fetch(BASE_URL + '/v1/paymentMethod', {
        method: 'POST',
        headers,
        body: JSON.stringify({
            paymentMethodId: paymentMethodId
        })
    })

    const cardResponse = await response.json()
    const paymentMethod = JSON.parse(cardResponse.body)
    return paymentMethod.card
}

